export default "__VITE_ASSET__BjGAdPGe__"